module.exports = __webpack_public_path__ + "static/media/loginlogo.cbd5e29b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/loginlogo.png
// module id = 409
// module chunks = 0